import { render } from "./App.vue?vue&type=template&id=22b3c6ca&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=22b3c6ca&lang=css"
import "./App.vue?vue&type=style&index=1&id=22b3c6ca&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b3c6ca"]])

export default __exports__